import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { media, mediaQuery } from '../../common/styles/styleUtil';
import leftArrow from './assets/leftArrow32new.png';
import rightArrow from './assets/rightArrow32new.png';

interface CarouselWrapperProps {
  start: number;
  end: number;
}
export const CarouselWrapper = styled.div<CarouselWrapperProps>`
  display: none;
  ${media.xs`
    display: block;
`};
  height: 100%;
  margin: 32px auto;
  position: relative;
  .ant-carousel {
    height: 100%;
    .slick-slider {
      height: 100%;
      .slick-list {
        height: 100%;
        .slick-slide {
          padding: 0;
          margin: 0;
          float: left;
          display: block;
          .card {
            margin-right: 30px;
            &:last-of-type {
              margin: 0;
            }
          }
        }
      }
      .slick-arrow {
        border-radius: 0;
        background-color: unset;
        box-shadow: none;
        position: absolute;
        width: 40px;
        height: 40px;
        z-index: 1;
        top: 287px;
        border-radius: 19.5px;
        border: solid 1px #d2d6da;
        background-color: #ffffff;
        &.slick-disabled {
          opacity: 0;
          cursor: default;
        }
        &.slick-next {
          right: 16px;
          &:before {
            content: url('${rightArrow}');
            margin-top: -10px;
            margin-right: 0;
            text-indent: 4px;
          }
        }
        &.slick-prev {
          left: 16px;
          &:before {
            content: url('${leftArrow}');
            margin-top: -10px;
            margin-right: 0;
            text-indent: 12px;
          }
        }
        &:hover {
          background-color: unset;
        }
        &:hover:not(.slick-disabled) {
          opacity: 1;
        }
        ${ifProp(
          'isOnContentPage',
          css`
            top: 220px;
            width: 40px;
            border-radius: 0;
            box-shadow: none;
          `,
        )}
      }

      .slick-dots {
        overflow: auto;
        position: absolute;
        top: 219px;
        align-items: center;
        z-index: 999;
        height: 34px;
        width: 100%;
        margin: 0 auto;
        li {
          vertical-align: middle;
          display: none;
          width: 6px;
          &:nth-child(n + ${(props) => props.start}):nth-child(
              -n + ${(props) => props.end}
            ) {
            display: inline-block;
          }
          &:nth-child(${(props) => props.start}) button {
            width: 4px;
            height: 4px;
          }
          &:nth-child(${(props) => props.end}) button {
            width: 4px;
            height: 4px;
          }
          button {
            width: 6px;
            height: 6px;
            background-color: #ffffff;
            border-radius: 4px;
            opacity: 0.5;
          }
          &.slick-active button {
            width: 8px;
            height: 8px;
            opacity: 1;
            background-color: #ffffff;
          }
        }
      }
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 24px;
  .ant-btn {
    border: solid 1px #2b6ed2;
    color: #2b6ed2;
    font-size: 14px;
    font-weight: bold;
  }
`;

export const CarouselCounter = styled.div`
  @media (${mediaQuery.tablet}) {
    margin-top: 18px;
    height: 40px;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.86;
    letter-spacing: normal;
    text-align: center;
    color: #333f48;
  }
`;

export const Description = styled.div`
  width: 750px;
  position: relative;
  height: auto;
  font-size: 18px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #697684;
  margin-top: 16px;
  word-break: break-word;
  @media (${mediaQuery.tablet}) {
    width: auto;
    font-size: 16px;
    margin-top: 24px;
    border-bottom: 1px solid #d2d6da;
    padding-bottom: 24px;
  }
  ${media.xs`
    padding: 0 16px 24px 16px;
  `}
`;
